import {
  ArgumentError,
  GeoipError,
  NotAllowedError,
  UnknownApiError,
} from './errors';

export default function (api) {
  /**
   * @typedef {Object} CategoryNode
   * @property {string} id
   * @property {Array.<Object>} items
   */

  /**
   * @memberof API
   * @instance
   */
  const geoip = {
    /**
     * This method triggers a geoip lookup and returns a result containing
     * the country code.
     *
     * Auth token is not required.
     *
     * @method
     * @this API
     *
     * @param {Object} payload
     * @param {string=} payload.ip, only allowed from server side
     *
     * @return {Promise} promise
     * @fulfill {Object}
     * @reject {GeoipError} Server returned 404, unable to determine country
     * @reject {NotAllowedError} Happens when supplying ip as argument client side
     * @reject {UnknownApiError} Server returned with unexpected status code
     * */
    lookup: function lookup(payload = {}) {
      if (payload.ip && typeof payload.ip !== 'string') {
        return Promise.reject(new ArgumentError('payload.ip must be a string'));
      }

      const data = payload.ip
        ? {
          data: { ip: payload.ip },
        }
        : undefined;
      const method = data ? 'post' : 'get';

      if (method === 'post' && typeof window !== 'undefined') {
        return Promise.reject(new NotAllowedError('Not allowed to make this call from within a browser'));
      }

      return this.request(method, '/geoip/v1/lookup', data)
        .then((res) => {
          switch (res.status) {
            case 200: {
              return res.body;
            }
            case 404: {
              throw new GeoipError('Country could not be resolved', res);
            }
            default: {
              throw new UnknownApiError('server returned with unhandled status code', res);
            }
          }
        })
        .catch((err) => {
          throw new GeoipError('Country could not be resolved', err);
        });
    }.bind(api),
  };

  return geoip;
}
